import { Component, OnInit, resolveForwardRef } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { Subscription, timer } from 'rxjs';
@Component({
  selector: 'app-adhoc',
  templateUrl: './adhoc.component.html',
  styleUrls: ['./adhoc.component.scss']
})
export class AdhocComponent implements OnInit {
  marketName: any;
  userTypeName: any = "0";
  marketList: any = [];
  tokenDetails: any;
  newcountry: any;
  marketSelect: any;
  tokencountry: any;
  res: any;
  adhocParamVariable: any;
  adhocParamDisableOn: boolean = true;
  adhocParamDisableOff: boolean = true;
  adhocParamcheckbox: any;
  adhocParamisChecked: boolean = false;
  skipDiagnosticOn = false
  skipDiagnosticOff = false
  adhocParamisOn: any;
  adhocParamisOff: any = false;
  adhocParamDisableCheck: any;
  radioadhoc: any;
  reRunNetworkConfig: any;
  reRunNetworkChecked: boolean = false;
  reRunNetworkDisable: boolean = false;
  corsisChecked: boolean = false;
  vehicleVariable: any;
  vehicleinputdisable: any;
  vehicleisChecked: boolean = false;
  vehiclecheckdisable: any;
  vehicledata: any = "SBD,APPLICATION";
  datavehicle: any;
  corsinputdisable: any;
  skipChecked: boolean = false;
  corscheckdisable: any
  corsdata: any = "https://wwwqa.fordtechservice.dealerconnection.com,https://wwwdev.fordtechservice.dealerconnection.com"
  corsVariable: any;
  skipVariable: any;
  reRunVariable: any;
  reRunError: boolean = false;
  datacors: any;
  datarerun: any;
  dataskip: any
  activateCSRFVariable: any;
  reRunNetworkVar: any;
  skipDiagnosticVariable: any;
  activateCSRFDisableOn: boolean = true;
  activateCSRFDisableOff: boolean = true;
  skipDiagnosticDisableOff: boolean = true;
  skipDiagnosticDisableOn: boolean = true;
  activateCSRFcheckbox: any;
  activateCSRFisChecked: boolean = false;
  activateCSRFisOn: any = true;
  activateCSRFisOff: any;
  activateCSRFDisableCheck: any;
  radioactivateCSRF: any;
  enableCSRFVariable: any;
  enableCSRFDisableOn: boolean = true;
  enableCSRFDisableOff: boolean = true;
  enableCSRFcheckbox: any;
  enableCSRFisChecked: boolean = false;
  enableCSRFisOn: any = true;
  enableCSRFisOff: any;
  enableCSRFDisableCheck: any;
  radioenableCSRF: any;
  filextinputdisable: any;
  filextisChecked: boolean = false;
  filextcheckdisable: any;
  filextdata: any = "7z,ab,APP,asc,bmp,cab,comms,csv,dbg,dll,doc,docx,ecd,GIF,ini,jpeg,JPG,json,log,lst,mht,mov,mp4,msg,oxps,pdf,png,pptx,rar,rtf,tml,tvs,txt,UMF,vc,vmm,xls,xlsx,xml,xps,zip,jar,jnlp,XML"
  filextVariable: any;
  datafilext: any;
  sanitizeVariable: any;
  sanitizeDisableOn: boolean = true;
  sanitizeDisableOff: boolean = true;
  sanitizecheckbox: any;
  sanitizeisChecked: boolean = false;
  sanitizeisOn: any = true;
  reRunNetworkCheckdisable: any = false
  skipCheckDisable: any = false
  sanitizeisOff: any;
  sanitizeDisableCheck: any;
  radiosanitize: any;
  crossVariable: any;
  crossDisableOn: boolean = true;
  crossDisableOff: boolean = true;
  crosscheckbox: any;
  crossisChecked: boolean = false;
  crossisOn: any = true;
  crossisOff: any;
  crossDisableCheck: any;
  radiocross: any;
  crossRemVariable: any;
  crossRemDisableOn: boolean = true;
  crossRemDisableOff: boolean = true;
  isDIagnosticProc = false;
  isReRunNetworkTest = false
  crossRemcheckbox: any;
  crossRemisChecked: boolean = false;
  crossRemisOn: any = true;
  crossRemisOff: any;
  crossRemDisableCheck: any;
  radiocrossRem: any;
  parameterList = [];
  showloadingadhoc: boolean = false;
  timer: any;
  flag: boolean = false;
  fdrsVersion: any;
  fdrsVersionError: boolean = false;
  dtcVariable: string = ''
  dtcChecked:boolean = false;
  dtcInfoOn: any = false;
  dtcInfoOff: any = false;
  dtcInfoDisabledOn: boolean = false;
  dtcInfoDisabledOff: boolean = false;
  dtcInfoChecked: boolean = false;
  dtcInfoDisableCheck: boolean = false;
  dtcDefaultInfo: any;
  subscription: Subscription = new Subscription;
  allowFDRSVersiontoEdit: boolean = false;
  // allowDTCvaluestoedit: boolean = false;
  dtcValueError: boolean = false;
  dtcNoofDaysValue: any;

  constructor(private service: ApifirstService) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data) => { this.tokenDetails = data })
    this.service.enableFDRSVersionEditPermissionInAdhoc.subscribe((data)=> { this.allowFDRSVersiontoEdit = data })
    this.getCountryList();
    this.marketSelect = "fromToken";
    this.marketName = this.tokenDetails.countryThree
    // this.onmarketSelect(this.marketName);
    let req = {
      "userType": this.userTypeName,
      "country": "default"
    }
    this.service.fetchAdhocParameters(req).subscribe((data) => {
      let res = data;
      for (let i in res.parameter) {
        switch (res.parameter[i].parameterKey) {
          case "UNSUPPORTED_OS_LOCKOUT": {
            if (res.parameter[i].value == "true") { this.radioadhoc = "On" }
            else { this.radioadhoc = "Off" } break;
          }
          case "PUBLISHABLE_EVENTS_LIST": {
            this.datavehicle = res.parameter[i].value; break;
          }
          case "SBDOWS_ALLOWED_ORIGINS": {
            this.datacors = res.parameter[i].value; break;
          }
          case "UPLOAD_FILE_EXT_TYPES_ALLOWED": {
            this.datafilext = res.parameter[i].value; break;
          }
          case "XSS_FILTER_LOGGING": {
            if (res.parameter[i].value == "true") { this.radiosanitize = "On" }
            else { this.radiosanitize = "Off" } break;
          }
          case "CSRF_ACTIVATED": {
            if (res.parameter[i].value == "true") { this.radioactivateCSRF = "On" }
            else { this.radioactivateCSRF = "Off" } break;
          }
          case "CSRF_ENABLED": {
            if (res.parameter[i].value == "true") { this.radioenableCSRF = "On" }
            else { this.radioenableCSRF = "Off" } break;
          }
          case "XSS_FILTER": {
            console.log("==============XSS-FILTER==========================", res.parameter[i].value)
            if (res.parameter[i].value == "true") { this.radiocross = "On" }
            else { this.radiocross = "Off" } break;
          }
          case "XSS_FILENAME_STRIPPING": {
            if (res.parameter[i].value == "true") { this.radiocrossRem = "On" }
            else { this.radiocrossRem = "Off" } break;
          }
          case "RE_RUN_NETWORK_TEST": {
            this.datarerun = res.parameter[i].value; break;

          }
          case "SKIP_DIAGNOSTIC_PROCEDURE": {
            console.log("==============SKIP==========================", res.parameter[i].value)
            if (res.parameter[i].value == "true") { this.dataskip = "On" }
            else { this.dataskip = "Off" } break;
          }
          case "DTC POPUP INFO": {
            console.log("==============DTC==========================", res.parameter[i].value)
            if (res.parameter[i].value == "true") { this.dtcDefaultInfo = "On" }
            else { this.dtcDefaultInfo = "Off" } break;
          }
          case "Minimum supported FDRS Version": {
            console.log("==============FDRS==========================", res.parameter[i].value)
            this.fdrsVersion = res.parameter[i].value; break;
          }
          case "HISTORIC DTC INFO": {
            console.log("==============FDRS==========================", res.parameter[i].value)
            this.dtcNoofDaysValue = res.parameter[i].value; break;
          }
          case "default": {/*do nothing*/ }
        }
      }
    })
  }
  getCountryList() {
    this.service.getCountryDetails().subscribe(
      (data) => {
        this.marketList = data
        this.marketList.sort((a: any, b: any) => (a.name > b.name) ? 1 : -1)
        for (let i in this.marketList) {
          if (this.tokenDetails.countryThree == this.marketList[i].id3) {
            this.newcountry = this.marketList[i].name;
            this.tokencountry = this.tokenDetails.countryThree;
          }
        }
        this.onmarketSelect(this.marketName);
      })
  }
  onmarketSelect(setmarketSelect: any) {
    this.showloadingadhoc = true;
    this.timer = timer(1000); // 2000 millisecond means 2 seconds
    this.subscription = this.timer.subscribe(() => {
      // set showloader to false to hide loading div from view after 2 seconds
      this.showloadingadhoc = false;
    });
    if (setmarketSelect == "fromToken") {
      this.marketName = this.tokencountry;
    }
    else {
      this.marketName = setmarketSelect;
    }
    if (this.marketName == "default" && this.userTypeName == "0") {
      this.onDefaultClick();
      this.getValuesOfmarketUser();
      this.onDefaultClick1();
      if (this.marketName == "default") {
        this.reRunNetworkDisable = true
      }
    }
    else {
      this.onDefaultClick();
      this.getValuesOfmarketUser();
    }
  }
  upateUserType(setUserType: any) {
    this.showloadingadhoc = true;
    this.timer = timer(1000); // 2000 millisecond means 2 seconds
    this.subscription = this.timer.subscribe(() => {
      // set showloader to false to hide loading div from view after 2 seconds
      this.showloadingadhoc = false;
    });
    this.userTypeName = setUserType
    if (this.marketName == "default" && this.userTypeName == "0") {
      this.onDefaultClick();
      this.getValuesOfmarketUser();
      this.onDefaultClick1();
    }
    else {
      this.onDefaultClick();
      this.getValuesOfmarketUser();
    }
  }
  getValuesOfmarketUser() {
    let req = {
      "userType": this.userTypeName,
      "country": this.marketName
    }
    this.service.fetchAdhocParameters(req).subscribe((data) => {
      let res = data;
      for (let i in res.parameter) {
        switch (res.parameter[i].parameterKey) {
          case "UNSUPPORTED_OS_LOCKOUT": {
            this.adhocParamVariable = res.parameter[i].value
            this.adhocParamisChecked = res.parameter[i].defaultValue
            if (this.adhocParamisChecked == false) {
              this.adhocParamDisableOn = false;
              this.adhocParamDisableOff = false;
              if (this.adhocParamVariable == "true") {
                this.adhocParamisOn = true
                this.adhocParamisOff = true
              }
              else {
                this.adhocParamisOff = false
                this.adhocParamisOn = false
              }
            }
            else {
              this.adhocParamDisableOn = true;
              this.adhocParamDisableOff = true;
            } break;
          }
          case "PUBLISHABLE_EVENTS_LIST": {
            this.vehicleVariable = res.parameter[i].value
            this.vehicleisChecked = res.parameter[i].defaultValue
            if (this.vehicleisChecked == false) {
              this.vehicleinputdisable = false;
              this.vehicledata = this.vehicleVariable
              this.datavehicle = this.vehicledata
            }
            else {
              this.vehicleinputdisable = true;
            } break;
          }
          case "SBDOWS_ALLOWED_ORIGINS": {
            this.corsVariable = res.parameter[i].value
            this.corsisChecked = res.parameter[i].defaultValue
            if (this.corsisChecked == false) {
              this.corsinputdisable = false;
              this.corsdata = this.corsVariable
              this.datacors = this.corsdata
            }
            else {
              this.corsinputdisable = true;
            } break;
          }
          case "UPLOAD_FILE_EXT_TYPES_ALLOWED": {
            this.filextVariable = res.parameter[i].value
            this.filextisChecked = res.parameter[i].defaultValue
            if (this.filextisChecked == false) {
              this.filextinputdisable = false;
              this.filextdata = this.filextVariable
              this.datafilext = this.filextdata
            }
            else {
              this.filextinputdisable = true;
            } break;
          }
          case "XSS_FILTER_LOGGING": {
            this.sanitizeVariable = res.parameter[i].value
            this.sanitizeisChecked = res.parameter[i].defaultValue
            if (this.sanitizeisChecked == false) {
              this.sanitizeDisableOn = false;
              this.sanitizeDisableOff = false;
              if (this.sanitizeVariable == "true") {
                this.sanitizeisOn = true
                this.sanitizeisOff = true
              }
              else {
                this.sanitizeisOff = false
                this.sanitizeisOn = false
              }
            }
            else {
              this.sanitizeDisableOn = true;
              this.sanitizeDisableOff = true;
            } break;
          }
          case "CSRF_ACTIVATED": {
            this.activateCSRFVariable = res.parameter[i].value
            this.activateCSRFisChecked = res.parameter[i].defaultValue
            if (this.activateCSRFisChecked == false) {
              this.activateCSRFDisableOn = false;
              this.activateCSRFDisableOff = false;
              if (this.activateCSRFVariable == "true") {
                this.activateCSRFisOn = true
                this.activateCSRFisOff = true
              }
              else {
                this.activateCSRFisOff = false
                this.activateCSRFisOn = false
              }
            }
            else {
              this.activateCSRFDisableOn = true;
              this.activateCSRFDisableOff = true;
            } break;
          }
          case "CSRF_ENABLED": {
            this.enableCSRFVariable = res.parameter[i].value
            this.enableCSRFisChecked = res.parameter[i].defaultValue
            if (this.enableCSRFisChecked == false) {
              this.enableCSRFDisableOn = false;
              this.enableCSRFDisableOff = false;
              if (this.enableCSRFVariable == "true") {
                this.enableCSRFisOn = true
                this.enableCSRFisOff = true
              }
              else {
                this.enableCSRFisOff = false
                this.enableCSRFisOn = false
              }
            }
            else {
              this.enableCSRFDisableOn = true;
              this.enableCSRFDisableOff = true;
            } break;
          }
          case "XSS_FILTER": {
            this.crossVariable = res.parameter[i].value
            this.crossisChecked = res.parameter[i].defaultValue
            if (this.crossisChecked == false) {
              this.crossDisableOn = false;
              this.crossDisableOff = false;
              if (this.crossVariable == "true") {
                this.crossisOn = true
                this.crossisOff = true
              }
              else {
                this.crossisOff = false
                this.crossisOn = false
              }
            }
            else {
              this.crossDisableOn = true;
              this.crossDisableOff = true;
            } break;
          }
          case "XSS_FILENAME_STRIPPING": {
            this.crossRemVariable = res.parameter[i].value
            this.crossRemisChecked = res.parameter[i].defaultValue
            if (this.crossRemisChecked == false) {
              this.crossRemDisableOn = false;
              this.crossRemDisableOff = false;
              if (this.crossRemVariable == "true") {
                this.crossRemisOn = true
                this.crossRemisOff = true
              }
              else {
                this.crossRemisOff = false
                this.crossRemisOn = false
              }
            }
            else {
              this.crossRemDisableOn = true;
              this.crossRemDisableOff = true;
            } break;
          }
          case "SKIP_DIAGNOSTIC_PROCEDURE": {
            this.skipVariable = res.parameter[i].value
            this.skipChecked = res.parameter[i].defaultValue
            if (this.skipChecked == false) {
              this.skipDiagnosticDisableOn = false;
              this.skipDiagnosticDisableOff = false;
              if (this.skipVariable == "true") {
                this.skipDiagnosticOn = true
                this.skipDiagnosticOff = true
              }
              else {
                this.skipDiagnosticOff = false
                this.skipDiagnosticOn = false
              }
            }
            else {
              this.skipDiagnosticDisableOn = true;
              this.skipDiagnosticDisableOff = true;
            } break;
          }
          case "RE_RUN_NETWORK_TEST": {
            this.reRunVariable = res.parameter[i].value
            this.reRunNetworkChecked = res.parameter[i].defaultValue
            if (this.reRunNetworkChecked == false) {
              if (this.marketName == "default") {
                this.reRunNetworkDisable = true
              }
              else {
                this.reRunNetworkDisable = false;
              }
              this.reRunNetworkConfig = this.reRunVariable
              if (this.marketName == "default" && (this.reRunVariable == "" || this.reRunVariable == null || this.reRunVariable == undefined)) {
                this.reRunNetworkConfig = "3"
              }
              // this.datarerun = this.reRunNetworkConfig
            }
            else {
              this.reRunNetworkConfig = this.reRunVariable;
              this.reRunNetworkDisable = true;
            } break;
          }
          case "DTC POPUP INFO": {
            this.dtcVariable = res.parameter[i].value
            this.dtcInfoChecked = res.parameter[i].defaultValue
            if (this.dtcInfoChecked == false) {
              this.dtcInfoDisabledOn = false;
              this.dtcInfoDisabledOff = false;
              if (this.dtcVariable == "true") {
                this.dtcInfoOn = true;
                this.dtcInfoOff = true;
              }
              else {
                this.dtcInfoOff = false;
                this.dtcInfoOn = false;
              }
            }
            else {
              this.dtcInfoDisabledOn = true;
              this.dtcInfoDisabledOff = true;
            } break;
          }
          case "Minimum supported FDRS Version": {
            console.log("==============FDRS==========================", res.parameter[i].value)
            this.fdrsVersion = res.parameter[i].value; break;
          }
          case "HISTORIC DTC INFO": {
            console.log("==============FDRS==========================", res.parameter[i].value)
            this.dtcNoofDaysValue = res.parameter[i].value; break;
          }
          case "default": { this.onDefaultClick(); }
        }
      }
      if (this.vehicleisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "PUBLISHABLE_EVENTS_LIST") {
              this.datavehicle = res.parameter[i].value
              this.vehicledata = this.datavehicle
            }
          }
        })
      }
      if (this.corsisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "SBDOWS_ALLOWED_ORIGINS") {
              this.datacors = res.parameter[i].value
              this.corsdata = this.datacors
            }
          }
        })
      }
      if (this.filextisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "UPLOAD_FILE_EXT_TYPES_ALLOWED") {
              this.datafilext = res.parameter[i].value
              this.filextdata = this.datafilext
            }
          }
        })
      }
      if (this.adhocParamisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "UNSUPPORTED_OS_LOCKOUT") {
              this.adhocParamVariable = res.parameter[i].value
              if (this.adhocParamVariable == "true") {
                this.adhocParamisOn = true
                this.adhocParamisOff = true
                this.radioadhoc = "On"
              }
              else {
                this.adhocParamisOff = false
                this.adhocParamisOn = false
                this.radioadhoc = "Off"
              }
            }
          }
        })
      }
      if (this.sanitizeisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "XSS_FILTER_LOGGING") {
              this.sanitizeVariable = res.parameter[i].value
              if (this.sanitizeVariable == "true") {
                this.sanitizeisOn = true
                this.sanitizeisOff = true
                this.radiosanitize = "On"
              }
              else {
                this.sanitizeisOff = false
                this.sanitizeisOn = false
                this.radiosanitize = "Off"
              }
            }
          }
        })
      }
      if (this.activateCSRFisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "CSRF_ACTIVATED") {
              this.activateCSRFVariable = res.parameter[i].value
              if (this.activateCSRFVariable == "true") {
                this.activateCSRFisOn = true
                this.activateCSRFisOff = true
                this.radioactivateCSRF = "On"
              }
              else {
                this.activateCSRFisOff = false
                this.activateCSRFisOn = false
                this.radioactivateCSRF = "Off"
              }
            }
          }
        })
      }
      if (this.enableCSRFisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "CSRF_ENABLED") {
              this.enableCSRFVariable = res.parameter[i].value
              if (this.enableCSRFVariable == "true") {
                this.enableCSRFisOn = true
                this.enableCSRFisOff = true
                this.radioenableCSRF = "On"
              }
              else {
                this.enableCSRFisOff = false
                this.enableCSRFisOn = false
                this.radioenableCSRF = "Off"
              }
            }
          }
        })
      }
      if (this.crossisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "XSS_FILTER") {
              this.crossVariable = res.parameter[i].value
              if (this.crossVariable == "true") {
                this.crossisOn = true
                this.crossisOff = true
                this.radiocross = "On"
              }
              else {
                this.crossisOff = false
                this.crossisOn = false
                this.radiocross = "Off"
              }
            }
          }
        })
      }
      if (this.crossRemisChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "XSS_FILENAME_STRIPPING") {
              this.crossRemVariable = res.parameter[i].value
              if (this.crossRemVariable == "true") {
                this.crossRemisOn = true
                this.crossRemisOff = true
                this.radiocrossRem = "On"
              }
              else {
                this.crossRemisOff = false
                this.crossRemisOn = false
                this.radiocrossRem = "Off"
              }
            }
          }
        })
      }
      if (this.skipChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "SKIP_DIAGNOSTIC_PROCEDURE") {
              this.skipVariable = res.parameter[i].value
              if (this.skipVariable == "true") {
                this.skipDiagnosticOn = true
                this.skipDiagnosticOff = true
                this.dataskip = "On"
              }
              else {
                this.skipDiagnosticOff = false
                this.skipDiagnosticOn = false
                this.dataskip = "Off"
              }
            }
          }
        })
      }
      if (this.dtcInfoChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "DTC POPUP INFO") {
              this.dtcVariable = res.parameter[i].value
              if (this.dtcVariable == "true") {
                this.dtcInfoOn = true
                this.dtcInfoOff = true
                this.dtcDefaultInfo = "On"
              }
              else {
                this.dtcInfoOff = false
                this.dtcInfoOn = false
                this.dtcDefaultInfo = "Off"
              }
            }
          }
        })
      }
      if (this.reRunNetworkChecked == true) {
        let req = {
          "userType": this.userTypeName,
          "country": "default"
        }
        this.service.fetchAdhocParameters(req).subscribe((data) => {
          let res = data;
          for (let i in res.parameter) {
            if (res.parameter[i].parameterKey == "RE_RUN_NETWORK_TEST") {
              this.datarerun = res.parameter[i].value
              this.reRunNetworkConfig = this.datarerun
            }
          }
        })
      }
    })
  }
  onDefaultClick() {
    this.adhocParamDisableCheck = false;
    this.adhocParamisChecked = true;
    this.adhocParamDisableOn = true;
    this.adhocParamDisableOff = true;
    this.vehiclecheckdisable = false;
    this.vehicleisChecked = true;
    this.vehicleinputdisable = true;
    this.corscheckdisable = false;
    this.corsisChecked = true;
    this.corsinputdisable = true;
    this.activateCSRFDisableCheck = false;
    this.activateCSRFisChecked = true;
    this.activateCSRFDisableOn = true;
    this.activateCSRFDisableOff = true;
    this.enableCSRFDisableCheck = false;
    this.enableCSRFisChecked = true;
    this.enableCSRFDisableOn = true;
    this.enableCSRFDisableOff = true;
    this.filextcheckdisable = false;
    this.filextisChecked = true;
    this.filextinputdisable = true;
    this.reRunNetworkCheckdisable = false
    this.reRunNetworkChecked = true
    this.reRunNetworkDisable = true;
    this.sanitizeDisableCheck = false;
    this.sanitizeisChecked = true;
    this.sanitizeDisableOn = true;
    this.sanitizeDisableOff = true;
    this.crossDisableCheck = false;
    this.crossDisableOn = true;
    this.crossDisableOff = true;
    this.crossisChecked = true;
    this.crossRemDisableCheck = false;
    this.crossRemDisableOn = true;
    this.crossRemDisableOff = true;
    this.crossRemisChecked = true;
    this.skipChecked = true
    this.skipCheckDisable = false;
    this.skipDiagnosticDisableOn = true;
    this.skipDiagnosticDisableOff = true;
    this.dtcInfoDisabledOn = true;
    this.dtcInfoDisabledOff = true;
    this.dtcInfoChecked = true;
    this.dtcInfoDisableCheck = false;
  }
  onDefaultClick1() {
    this.adhocParamDisableCheck = true;
    this.adhocParamisChecked = false;
    this.adhocParamDisableOn = false;
    this.adhocParamDisableOff = false;
    this.vehiclecheckdisable = true;
    this.vehicleisChecked = false;
    this.vehicleinputdisable = false;
    this.corscheckdisable = true;
    this.corsisChecked = false;
    this.corsinputdisable = false;
    this.activateCSRFDisableCheck = true;
    this.activateCSRFisChecked = false;
    this.activateCSRFDisableOn = false;
    this.activateCSRFDisableOff = false;
    this.enableCSRFDisableCheck = true;
    this.enableCSRFisChecked = false;
    this.enableCSRFDisableOn = false;
    this.enableCSRFDisableOff = false;
    this.filextcheckdisable = true;
    this.filextisChecked = false;
    this.filextinputdisable = false;
    this.reRunNetworkCheckdisable = true
    this.reRunNetworkChecked = false
    this.reRunNetworkDisable = false;
    this.sanitizeDisableCheck = true;
    this.sanitizeisChecked = false;
    this.sanitizeDisableOn = false;
    this.sanitizeDisableOff = false;
    this.crossDisableCheck = true;
    this.crossDisableOn = false;
    this.crossDisableOff = false;
    this.crossisChecked = false;
    this.crossRemDisableCheck = true;
    this.crossRemDisableOn = false;
    this.crossRemDisableOff = false;
    this.crossRemisChecked = false;
    this.skipChecked = false
    this.skipCheckDisable = true;
    this.skipDiagnosticDisableOn = false;
    this.skipDiagnosticDisableOff = false;
    this.dtcInfoDisabledOn = false;
    this.dtcInfoDisabledOff = false;
    this.dtcInfoChecked = false;
    this.dtcInfoDisableCheck = true;
  }
  adhocParamOnChange(value: string) {
    this.adhocParamVariable = value;
  }
  adhocParamChecked(adhocParamisChecked: any) {
    if (adhocParamisChecked == false) {
      this.adhocParamDisableOn = false;
      this.adhocParamDisableOff = false;
    }
    else {
      this.adhocParamDisableOn = true;
      this.adhocParamDisableOff = true;
    }
  }
  vehicleDataChange(value: string) {
    this.vehicledata = value
  }
  vehicleChecked(vehicleisChecked: any) {
    if (vehicleisChecked == false) {
      this.vehicleinputdisable = false;
    }
    else {
      this.vehicleinputdisable = true;
    }
  }
  corsDataChange(value: string) {
    this.corsdata = value
  }
  corsChecked(corsisChecked: any) {
    if (corsisChecked == false) {
      this.corsinputdisable = false;
    }
    else {
      this.corsinputdisable = true;
    }
  }
  activateCSRFOnChange(value: string) {
    this.activateCSRFVariable = value;
  }
  skipDiagnosticProc(value: any) {
    this.skipVariable = value;
  }
  skipCheck(skipChecked: any) {
    if (skipChecked == false) {
      this.skipDiagnosticDisableOn = false;
      this.skipDiagnosticDisableOff = false;
    }
    else {
      this.skipDiagnosticDisableOn = true;
      this.skipDiagnosticDisableOff = true;
    }
  }
  reRunNetwork(value: any) {
    this.reRunNetworkConfig = value;
  }

  fdrsVersionChange(value: any) {
  var regex = /^[0-9]{0,2}(\.[0-9]{0,1}\.[0-9]{0,1}[0-9])$/;
    let test = regex.test(value);
    if(test) {
      this.fdrsVersionError = false;
    } else {
      this.fdrsVersionError = true;
    }
  }

  setDTCValues(value: any) {
   var dtcregex = /^(?!0*(\.0+)?$)(\d+|\d*\.\d+)$/;
   let test = dtcregex.test(value);
   if(test) {
    this.dtcValueError = false;
   } else {
    this.dtcValueError = true;
   }
  }

  reRunNetworkCheck(reRunNetworkChecked: any) {
    if (reRunNetworkChecked == false) {
      if (this.marketName == "default") {
        this.reRunNetworkDisable = true
      }
      else {
        this.reRunNetworkDisable = false;
      }
    }
    else {
      this.reRunNetworkDisable = true;
    }
    if (reRunNetworkChecked == true) {
      this.reRunNetworkConfig = '3';
      this.reRunError = false;
    }
  }
  activateCSRFChecked(activateCSRFisChecked: any) {
    if (activateCSRFisChecked == false) {
      this.activateCSRFDisableOn = false;
      this.activateCSRFDisableOff = false;
    }
    else {
      this.activateCSRFDisableOn = true;
      this.activateCSRFDisableOff = true;
    }
  }
  enableCSRFOnChange(value: string) {
    this.enableCSRFVariable = value;
  }
  enableCSRFChecked(enableCSRFisChecked: any) {
    if (enableCSRFisChecked == false) {
      this.enableCSRFDisableOn = false;
      this.enableCSRFDisableOff = false;
    }
    else {
      this.enableCSRFDisableOn = true;
      this.enableCSRFDisableOff = true;
    }
  }
  filextDataChange(value: string) {
    this.filextdata = value
  }
  filextChecked(filextisChecked: any) {
    if (filextisChecked == false) {
      this.filextinputdisable = false;
    }
    else {
      this.filextinputdisable = true;
    }
  }
  sanitizeOnChange(value: string) {
    this.sanitizeVariable = value;
  }
  sanitizeChecked(sanitizeisChecked: any) {
    if (sanitizeisChecked == false) {
      this.sanitizeDisableOn = false;
      this.sanitizeDisableOff = false;
    }
    else {
      this.sanitizeDisableOn = true;
      this.sanitizeDisableOff = true;
    }
  }
  crossOnChange(value: string) {
    this.crossVariable = value;
  }
  crossChecked(crossisChecked: any) {
    if (crossisChecked == false) {
      this.crossDisableOn = false;
      this.crossDisableOff = false;
    }
    else {
      this.crossDisableOn = true;
      this.crossDisableOff = true;
    }
  }
  crossRemOnChange(value: string) {
    this.crossRemVariable = value;
  }
  crossRemChecked(crossRemisChecked: any) {
    if (crossRemisChecked == false) {
      this.crossRemDisableOn = false;
      this.crossRemDisableOff = false;
    }
    else {
      this.crossRemDisableOn = true;
      this.crossRemDisableOff = true;
    }
  }
  changeDtcInfoChecked(defaultCheck: any) {
    if(defaultCheck == true) {
      this.dtcInfoDisabledOn = true;
      this.dtcInfoDisabledOff = true;
    } else {
      this.dtcInfoDisabledOn = false;
      this.dtcInfoDisabledOff = false;
    }
  }
  enableDisableDTCInfo(DtcInfo: string) {
    this.dtcVariable = DtcInfo;
  }
  updateParameters() {
    if (!this.reRunNetworkConfig) {
      this.reRunError = true;
    } else if (this.fdrsVersionError) {
      this.fdrsVersionError = true;
    } else {
      this.reRunError = false;
      this.showloadingadhoc = true;
      this.timer = timer(1000); // 2000 millisecond means 2 seconds
      this.subscription = this.timer.subscribe(() => {
        // set showloader to false to hide loading div from view after 2 seconds
        this.showloadingadhoc = false;
      });
      let parameterList = [];
      const adhocParamObj = {
        "parameterKey": "UNSUPPORTED_OS_LOCKOUT",
        "value": this.adhocParamVariable.toString(),
        "parameterGroup": "Adhoc Parameter",
        "defaultValue": this.adhocParamisChecked
      }
      parameterList.push(adhocParamObj)

      const vehicleObj = {
        "parameterKey": "PUBLISHABLE_EVENTS_LIST",
        "value": this.vehicledata.toString(),
        "parameterGroup": "Vehicle events parameters",
        "defaultValue": this.vehicleisChecked
      }
      parameterList.push(vehicleObj)

      const corsObj = {
        "parameterKey": "SBDOWS_ALLOWED_ORIGINS",
        "value": this.corsdata.toString(),
        "parameterGroup": "SBD WS CORS Config",
        "defaultValue": this.corsisChecked
      }
      parameterList.push(corsObj)

      const filextObj = {
        "parameterKey": "UPLOAD_FILE_EXT_TYPES_ALLOWED",
        "value": this.filextdata.toString(),
        "parameterGroup": "Security",
        "defaultValue": this.filextisChecked
      }
      parameterList.push(filextObj)

      const sanitizeObj = {
        "parameterKey": "XSS_FILTER_LOGGING",
        "value": this.sanitizeVariable.toString(),
        "parameterGroup": "Security",
        "defaultValue": this.sanitizeisChecked
      }
      parameterList.push(sanitizeObj)

      const activateCSRFObj = {
        "parameterKey": "CSRF_ACTIVATED",
        "value": this.activateCSRFVariable.toString(),
        "parameterGroup": "Security",
        "defaultValue": this.activateCSRFisChecked
      }
      parameterList.push(activateCSRFObj)

      const enableCSRFObj = {
        "parameterKey": "CSRF_ENABLED",
        "value": this.enableCSRFVariable.toString(),
        "parameterGroup": "Security",
        "defaultValue": this.enableCSRFisChecked
      }
      parameterList.push(enableCSRFObj)

      const crossObj = {
        "parameterKey": "XSS_FILTER",
        "value": this.crossVariable.toString(),
        "parameterGroup": "Security",
        "defaultValue": this.crossisChecked
      }
      parameterList.push(crossObj)

      const crossRemObj = {
        "parameterKey": "XSS_FILENAME_STRIPPING",
        "value": this.crossRemVariable.toString(),
        "parameterGroup": "Security",
        "defaultValue": this.crossRemisChecked
      }
      parameterList.push(crossRemObj)
      const skipDianosticProcedureObj = {
        "parameterKey": "SKIP_DIAGNOSTIC_PROCEDURE",
        "value": this.skipVariable.toString(),
        "parameterGroup": "NetworkTest",
        "defaultValue": this.skipChecked
      }
      parameterList.push(skipDianosticProcedureObj)
      const networktest = {
        "parameterKey": "RE_RUN_NETWORK_TEST",
        "value": this.reRunNetworkConfig.toString(),
        "parameterGroup": "NetworkTest",
        "defaultValue": this.reRunNetworkChecked
      }
      parameterList.push(networktest)
      const fdrsVersionUpdate = {
        "parameterKey": "Minimum supported FDRS Version",
        "value": this.fdrsVersion.toString(),
        "defaultValue": false,
        "parameterGroup": "FDRS"
      }
      parameterList.push(fdrsVersionUpdate)
      const dtcInfo = {
        "parameterKey": "DTC POPUP INFO",
        "value": this.dtcVariable.toString(),
        "defaultValue": this.dtcInfoChecked,
        "parameterGroup": "DTC"
      }
      parameterList.push(dtcInfo)
      const setNoOfDaysDTCValues = {
        "parameterKey": "HISTORIC DTC INFO",
        "value": this.dtcNoofDaysValue.toString(),
        "defaultValue": false,
        "parameterGroup": "HISTORIC DTC"
      }
      parameterList.push(setNoOfDaysDTCValues)
      const req =
      {
        "userType": this.userTypeName,
        "market": this.marketName,
        "parameter": parameterList
      }
      this.service.insertAdhocParameters(req).subscribe((data) => {
        this.res = data;
         if (this.marketName == "default") {
          for (let i in this.res.parameter) {
            switch (this.res.parameter[i].parameterKey) {
              case "UNSUPPORTED_OS_LOCKOUT": {
                if (this.res.parameter[i].value == "true") { this.radioadhoc = "On" }
                else { this.radioadhoc = "Off" } break;
              }
              case "PUBLISHABLE_EVENTS_LIST": {
                this.datavehicle = this.res.parameter[i].value; break;
              }
              case "SBDOWS_ALLOWED_ORIGINS": {
                this.datacors = this.res.parameter[i].value; break;
              }
              case "UPLOAD_FILE_EXT_TYPES_ALLOWED": {
                this.datafilext = this.res.parameter[i].value; break;
              }
              case "XSS_FILTER_LOGGING": {
                if (this.res.parameter[i].value == "true") { this.radiosanitize = "On" }
                else { this.radiosanitize = "Off" } break;
              }
              case "CSRF_ACTIVATED": {
                if (this.res.parameter[i].value == "true") { this.radioactivateCSRF = "On" }
                else { this.radioactivateCSRF = "Off" } break;
              }
              case "CSRF_ENABLED": {
                if (this.res.parameter[i].value == "true") { this.radioenableCSRF = "On" }
                else { this.radioenableCSRF = "Off" } break;
              }
              case "XSS_FILTER": {
                if (this.res.parameter[i].value == "true") { this.radiocross = "On" }
                else { this.radiocross = "Off" } break;
              }
              case "XSS_FILENAME_STRIPPING": {
                if (this.res.parameter[i].value == "true") { this.radiocrossRem = "On" }
                else { this.radiocrossRem = "Off" } break;
              }
              case "RE_RUN_NETWORK_TEST": {
                this.datarerun = this.res.parameter[i].value; break;
              }
              case "DTC POPUP INFO": {
                console.log("==============DTC==========================", this.res.parameter[i].value)
                if (this.res.parameter[i].value == "true") {
                  this.dtcDefaultInfo = "On",
                  this.dtcInfoOn = true;
              } else {
                    this.dtcDefaultInfo = "Off",
                    this.dtcInfoOff = false;
                  } break;
              }
              case "SKIP_DIAGNOSTIC_PROCEDURE": {
                if (this.res.parameter[i].value == "true") { this.dataskip = "On" }
                else { this.dataskip = "Off" } break;
              }
              case "default": {/* do nothing */ }
            }
          }
         }
          this.getValuesOfmarketUser();
      })
    }
  }
  // reRunNetworkTest() {

  //   this.rpcClientService.runNetworkTest("", "");
  // }
}
